import request from 'sb-request'
import actions from 'redux/actions'
import { getState } from 'redux/core'
import { constants, mixpanel } from 'common/helpers'
import { getCookieValue, getFeatureToggle } from 'helpers'


const setupBegin = ({ endpoint, tokenName, withSubscriptionCase }) => (values) => {
  const {
    models: { payment: { subscriptionCase } },
    view: {
      paymentPage: { bill: { offer: billOffer } },
      pickPage: { selectedItems },
    },
  } = getState()

  mixpanel.track(constants.analyticsEvents.tech.beginStart)

  const offer                                     = billOffer || getCookieValue(constants.cookieNames.offer)
  const isPremiumProductsForNotSubscribedEnabled  = getFeatureToggle(constants.features.premiumProductsForNotSubscribed)

  if (isPremiumProductsForNotSubscribedEnabled && selectedItems.length) {
    values.pickedProducts = selectedItems.map(({ id }) => id)
  }

  const body = { ...values, offer }

  if (withSubscriptionCase && subscriptionCase) {
    body.subscriptionCase = true
  }

  return request.post(endpoint, {
    body,
    tokenName,
  })
    .then(
      (result) => {
        mixpanel.track(constants.analyticsEvents.tech.beginSuccess)

        return result
      },
      (err) => {
        const { resData: { token } } = err

        mixpanel.track(constants.analyticsEvents.tech.beginError)

        if (token) {
          actions.models.requestTokens.update({
            [tokenName]: token,
          })
        }

        return Promise.reject(err)
      }
    )
}


export default setupBegin
